type BookingIdViewProps =  {
    id: number,
    inSeasonId: number
}

const BookingIdView = (props: BookingIdViewProps) => {
    return <><span>{props.inSeasonId}</span><span className="text-neutral-400 dark:text-neutral-600"> - {props.id}</span></>;
}

export default BookingIdView;
